module.exports = __webpack_public_path__ + "files/f99ad34d4d09736f5e76dd108f38e1bb.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-7.png
// module id = 504
// module chunks = 76